import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "8",
      cy: "8",
      r: "8",
      fill: "#6166FF"
    }, null, -1),
    _createElementVNode("path", {
      d: "M5 13V4H8.91042C9.86048 4 10.6129 4.25926 11.1678 4.77778C11.7226 5.28889 12 5.98519 12 6.86667C12 7.74074 11.7188 8.43704 11.1564 8.95556C10.6015 9.47407 9.85288 9.73333 8.91042 9.73333H6.88111V13H5ZM6.88111 8.1H8.79642C9.19924 8.1 9.51846 7.98889 9.75407 7.76667C9.98969 7.54444 10.1075 7.24444 10.1075 6.86667C10.1075 6.48889 9.98969 6.18889 9.75407 5.96667C9.51846 5.74444 9.19924 5.63333 8.79642 5.63333H6.88111V8.1Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }